const axios = require("axios");
const {HOST} = require("./consts");

export const API = axios.create({
    baseURL: HOST,
    timeout: 60000
});

API.interceptors.request.use(
  async config => {
    config.headers.common['user_auth_token'] = window.localStorage.getItem('user_auth_token');
    config.headers.common['user_id'] = window.localStorage.getItem('user_id');
    config.headers.common['auth_token_expiry'] = window.localStorage.getItem('auth_token_expiry');
    config.headers.common['user_role'] = window.localStorage.getItem('user_role');
    return config;
  },
  error => {
    Promise.reject(error)
});

API.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    // if the error is 403 (which is sent from backend), then redirect to /login
    if(error.response) {
      if(error.response.status === 403) {
        window.location.assign(error.response.data.redirect);
      }
    }
    return Promise.reject(error);
  });